import { statusLabels } from "constants";

export const OrderStatusUtils = {
  getStatusLabel: (status, t) =>
    statusLabels(t).find((obj) => obj?.value === status),
};
